import { useState, useEffect, useCallback } from 'react';
import supabase from '../supabase';
import { KLOOK_AID } from '../constants';

const useAffiliateReward = (user) => {
  const [affiliateReward, setAffiliateReward] = useState(null);
  const [affToast, setAffToast] = useState(false);

  const checkAffiliateReward = useCallback(async (uid) => {
    if (!uid) { setAffiliateReward(null); return; }
    try {
      const { data } = await supabase
        .from('affiliate_rewards')
        .select('expires_at, platform, used_at')
        .eq('user_id', uid)
        .gte('expires_at', new Date().toISOString())
        .is('used_at', null)
        .maybeSingle();
      setAffiliateReward(data || null);
    } catch { setAffiliateReward(null); }
  }, []);

  useEffect(() => { checkAffiliateReward(user?.id); }, [user?.id]); // eslint-disable-line

  useEffect(() => {
    const onAffClick = async (e) => {
      const a = e.target.closest('a[href]');
      if (!a || !user?.id) return;
      const href = a.href || '';
      let platform = null;
      if (href.includes('klook.com') && href.includes(KLOOK_AID)) platform = 'Klook';
      else if (href.includes('kkday.com')) platform = 'KKday';
      if (!platform || affiliateReward) return;
      // 每個用戶每年最多發一次：已用過或過期的紀錄仍在一年內就唔再發，
      // 否則 upsert 會用 used_at:null 覆蓋舊紀錄，等於無限重複解鎖 14 天
      const { data: prev, error: prevErr } = await supabase
        .from('affiliate_rewards')
        .select('earned_at')
        .eq('user_id', user.id)
        .maybeSingle();
      if (prevErr) return;
      const oneYearAgo = new Date();
      oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
      if (prev?.earned_at && new Date(prev.earned_at) > oneYearAgo) return;
      const expiresAt = new Date();
      expiresAt.setFullYear(expiresAt.getFullYear() + 1);
      const reward = {
        user_id: user.id, platform,
        earned_at: new Date().toISOString(),
        expires_at: expiresAt.toISOString(),
        used_at: null, days_used: null,
      };
      const { error } = await supabase.from('affiliate_rewards').upsert(reward, { onConflict: 'user_id' });
      if (!error) {
        setAffiliateReward({ expires_at: expiresAt.toISOString(), platform });
        setAffToast(true);
        setTimeout(() => setAffToast(false), 4500);
      }
    };
    document.addEventListener('click', onAffClick);
    return () => document.removeEventListener('click', onAffClick);
  }, [user?.id, affiliateReward]); // eslint-disable-line

  return { affiliateReward, setAffiliateReward, affToast, checkAffiliateReward };
};

export default useAffiliateReward;
